import React, {useEffect, useState} from 'react'
import {Row} from "react-bootstrap";

import Loading from '../../component/Loading/Loading';
import Table from './Table';
import {ModalWithGrid} from '../Modal/ModalWithGrid';
import PortalTransactionsEpcGrid from '../../customGrid/entities/PortalTransactionsEpcGrid';
import {ButtonHeader} from '../Button/ButtonHeader';
import TransactionItemService from '../../services/TransactionItemsService';
import Notify from '../../services/Notify';
import {ModalMessage} from '../Modal/ModalMessage';
import SwitchWithLabel from '../Checkbox/SwitchWithLabel';

const epcGridMetadata = new PortalTransactionsEpcGrid();
const transactionItemService = new TransactionItemService();

export const TransactionTable = ({transaction, readpointId}) => {

  if (!transaction) {
    return <Loading/>
  }

  const [dataTable, setDataTable] = useState(transaction)
  const [showModal, setShowModal] = useState(false)
  const [showWarnDeleteAll, setShowWarnDeleteAll] = useState(false)
  const [onlyWorkFlowError, setOnlyWorkFlowError] = useState(false)
  const [productModal, setProductModal] = useState(null)
  const [referenceModal, setReferenceModal] = useState(null)
  const [transactionId, setTransactionId] = useState(null)
  const [productTypeId, setProductTypeId] = useState(null)

  useEffect(() => {
    if (transaction) {
      const { items, ...transactionWithoutItems } = transaction 
      const itemsSortedByReference = items && items.sort((a, b) => (a.reference > b.reference) ? 1 : -1)
      setDataTable({ items: itemsSortedByReference, ...transactionWithoutItems })
    }
  }, [transaction])

  const tableTitle = ['Referência', 'Descrição', 'Qtde Solicitada', 'Qtde Disponivel', 'Qtde Alvo', 'Qtde Lida RFID']

  const setModalData = (productName, productReference, transactionId, productTypeId) => {
    setProductModal(productName)
    setReferenceModal(productReference)
    setTransactionId(transactionId)
    setProductTypeId(productTypeId)
    setShowModal(true)
  }

  const getQuantityColorStatus = (quantityExpected, quantity) => {
    quantity = !quantity ? 0 : quantity
    quantityExpected = !quantityExpected ? 0 : quantityExpected

    if (dataTable.movementOrder === null) {
      return styles.numberTable
    }

    if (quantity === quantityExpected) {
      return Object.assign({}, styles.successStatus, styles.numberTable);
    }

    if(quantityExpected === 0){
      return Object.assign({}, styles.dangerStatus, styles.numberTable);
    }

    if(quantity < quantityExpected){
      return styles.numberTable;
    }

    if (quantity > quantityExpected) {
      return Object.assign({}, styles.warningStatus, styles.numberTable);
    }
  }

  const deleteAllItems = async () => {
    try {
      await transactionItemService.deleteAllTransactionItems(transactionId, productTypeId)
      Notify.success('Itens deletados com sucesso!')
      setShowModal(false)
    } catch (error) {
      Notify.error('Houve um erro ao deletar todos os itens', error)
    }
  }

  return (
      dataTable.items.length === 0 ? <Row style={styles.message}>Por favor passe itens pelo portal</Row> :
          <Table>
            <thead>
            <tr>
              {tableTitle.map((title, index) => {
                return <th key={index} style={styles.textTable}>{title}</th>
              })}
            </tr>
            </thead>
            <tbody>
            {dataTable.items.map((item, index) => {
              return (
                  <tr onClick={() => {
                    setModalData(item.friendlyName, item.reference, transaction.id, item.id)
                  }} key={index}>
                    <td style={{ ...styles.textTable, fontWeight: 'bold' }}>{item.reference ? item.reference : '0'}</td>
                    <td style={styles.textTable}>{item.friendlyName ? item.friendlyName : '0'}</td>
                    <td style={styles.numberTable}>{item.quantityExpected ? item.quantityExpected : '0'}</td>
                    <td style={styles.numberTable}>{item.availableQuantity ? item.availableQuantity : '0'}</td> 
                    <td style={styles.numberTable}>{item.quantityTarget ? item.quantityTarget : '0'}</td>
                    <td style={getQuantityColorStatus(item.quantityExpected, item.quantity)}>{item.quantity ? item.quantity : '0'}</td>
                  </tr>
              )
            })}
            </tbody>
            <ModalWithGrid 
              title="Produto"
              subtitle={`${referenceModal} - ${productModal}`}
              actions={[
                <ButtonHeader
                  title="Remover todos os produtos"
                  icon="trash fa-2x"
                  style={{
                    border: 'none',
                    outline: 'none',
                    backgroundColor: 'transparent'
                  }}
                  iconStyle={{color: '#ff6961 '}}
                  onClick={() => setShowWarnDeleteAll(true)}
                />
              ]}
              customFilters={[
                <SwitchWithLabel
                  label="Mostrar apenas itens com workflow inválido"
                  width={50}
                  height={20}
                  checked={onlyWorkFlowError}
                  onChange={() => setOnlyWorkFlowError(!onlyWorkFlowError)}
                />
              ]}
              handleShowModal={() => setShowModal(!showModal)}
              metadata={epcGridMetadata}
              endpoint={epcGridMetadata.endpoint}
              addParams={params => {
                productTypeId && params.append('productTypeId', productTypeId)
                transactionId && params.append('transactionId', transactionId)
                onlyWorkFlowError && params.append('onlyWorkFlowError', onlyWorkFlowError)
                params.append('active', true)
              }}
              showModal={showModal}
            />
            <ModalMessage
              title="Tem certeza que deseja excluir todos os itens?"
              showModal={showWarnDeleteAll}
              handleShowModal={setShowWarnDeleteAll}
              successButtonAction={deleteAllItems}
            />
          </Table>
  )
}

const styles = {
  textTable: {
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center'
  },
  numberTable: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center'
  },
  message: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    fontSize: '20px',
    lineHeight: '20px',
    marginTop: '15%'
  },
  successStatus: {
    background: '#6fe1ae'
  },
  warningStatus: {
    background: '#f7f2d5'
  },
  dangerStatus: {
    background: '#f9d1d1'
  }
}



// WEBPACK FOOTER //
// ./src/component/Table/TransactionTable.js